import React, { useState } from "react";
import { Stepper, Step, StepLabel, Button, CssBaseline } from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { motion } from "framer-motion"; // Import motion from framer-motion
import HostelApplicationForm from "./HostalForm";
import HostelMessManagement from "./messData";
import HostelDoctorCheckup from "./DoctorCheckup";
import PersonalDetails from "../../assets/hotelPdf/PersonalDetails.pdf";
import hostelrulebook from "../../assets/hotelPdf/hostelrulebook.pdf";
import mass from "../../assets/Home/mass.jpeg";
import mass2 from "../../assets/Home/mass2.jpeg";
import mass3 from "../../assets/Home/mass3.jpeg";
// import college from "../../assets/Home/"

// import studentinfo from "../";
// Define steps
const steps = ["Application Form", "Mess Management", "Doctor Checkup"];

// Create a Material-UI theme
const theme = createTheme({
  palette: {
    primary: {
      main: "#00BFA5",
    },
    secondary: {
      main: "#d32f2f",
    },
  },
});

export default function HostelManagementApp() {
  const [activeStep, setActiveStep] = useState(0);

  const handleNext = () => {
    setActiveStep((prevStep) => prevStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return <HostelApplicationForm />;
      case 1:
        return <HostelMessManagement />;
      case 2:
        return <HostelDoctorCheckup />;
      default:
        return <div>Unknown step</div>;
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      {/* Hostel Facilities Overview */}
      <div className="text-center px-4 py-6">
        <h3 className="text-2xl font-semibold text-[#00BFA5] mb-4">
          Hostel Facilities
        </h3>
        <div className="flex flex-wrap justify-center gap-4 text-lg text-gray-700">
          <div className="bg-gray-100 border border-teal-300 rounded-xl px-4 py-2 shadow-md">
            Fresh & Healthy Food
          </div>
          <div className="bg-gray-100 border border-teal-300 rounded-xl px-4 py-2 shadow-md">
            RO Purified Water
          </div>
          <div className="bg-gray-100 border border-teal-300 rounded-xl px-4 py-2 shadow-md">
            Free Meal Services
          </div>
          <div className="bg-gray-100 border border-teal-300 rounded-xl px-4 py-2 shadow-md">
            Indoor & Outdoor Sports
          </div>
          <div className="bg-gray-100 border border-teal-300 rounded-xl px-4 py-2 shadow-md">
            Meditation Sessions
          </div>
          <div className="bg-gray-100 border border-teal-300 rounded-xl px-4 py-2 shadow-md">
            Yoga Classes
          </div>
        </div>
      </div>

      <h2 className="font-semibold text-2xl items-center text-center text-[#00BFA5] p-4">
        HOSTEL MESS
      </h2>

      <div className="flex">
        {/* Animated College Image */}
        <motion.img
          src={mass}
          alt="mess"
          className="w-1/3 h-1/2 shadow-md p-2 border-4 border-teal-500 rounded-lg"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        />

        <motion.img
          src={mass2}
          alt="mess"
          className="w-1/3 ml-16  h-1/2 shadow-md p-2 border-4 border-teal-500 rounded-lg"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        />
        {/* <motion.img
                    src={mass3}
                    alt="CSE"
                    className="w-1/4 h-1/3 shadow-md p-2 border-4 border-teal-500 rounded-lg"
                    initial={{ opacity: 0, y: -50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1 }}
                  /> */}
      </div>
      {/* <div className="min-h-screen bg-gray-100 flex items-center justify-center p-6 ">
        <div className="max-w-4xl w-full bg-white p-8 rounded-lg shadow-md border-4 border-[#00BFA5]">
          <h1 className="text-3xl font-bold text-center mb-6 text-gray-700">
            Hostel Management System
          </h1>
          <Stepper activeStep={activeStep} alternativeLabel>
            {steps.map((label, index) => (
              <Step key={index}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>

          {activeStep === steps.length ? (
            <motion.div
              className="text-center mt-8"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              <h2 className="text-xl font-semibold text-green-600 mb-4">
                All steps completed!
              </h2>
              <Button
                variant="contained"
                color="primary"
                onClick={handleReset}
                className="mt-4"
              >
                Reset
              </Button>
            </motion.div>
          ) : (
            <>
              <motion.div
                className="mt-6"
                key={activeStep} // Unique key to trigger animation on step change
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 20 }}
                transition={{ duration: 0.5 }}
              >
                {renderStepContent(activeStep)}
              </motion.div>
              <div className="flex justify-between mt-6">
                <Button
                  variant="contained"
                  color="secondary"
                  disabled={activeStep === 0}
                  onClick={handleBack}
                >
                  Back
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleNext}
                >
                  {activeStep === steps.length - 1 ? "Finish" : "Next"}
                </Button>
              </div>
            </>
          )}
        </div>
      </div> */}
      <div id="container" className="p-2">
        {/* PDF Viewer with Iframe */}

        {/* Download Button */}
        <a
          href={PersonalDetails}
          download="PersonalDetails.pdf"
          className="mt-4 inline-block px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
        >
          Personal Details PDF
        </a>
        <a
          href={hostelrulebook}
          download="hostelrulebook.pdf"
          className="mt-4 inline-block px-4 py-2 ml-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
        >
          hostel Rulebook PDF
        </a>
      </div>
    </ThemeProvider>
  );
}
